import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder my-2" }, [
  /*#__PURE__*/_createTextVNode(" MID Applications"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-6 text-gray-400 fw-bold ms-1" })
], -1)
const _hoisted_2 = { class: "d-flex flex-wrap my-5" }
const _hoisted_3 = { class: "card h-100" }
const _hoisted_4 = { class: "card-body d-flex justify-content-center text-center flex-column p-8 ps-7 pe-7" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-60px mb-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    class: "w-auto h-auto",
    src: "/media/svg/files/folder-document.svg"
  })
], -1)
const _hoisted_6 = { class: "fs-5 fw-bolder mb-2" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Documents: ")
const _hoisted_11 = { class: "badge badge-sm badge-light" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" approved: ")
const _hoisted_15 = { class: "badge badge-sm badge-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationFiles, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "col-3 me-3"
        }, [
          _createTextVNode(_toDisplayString(item.fileid) + " ", 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: `/merchants/applications/details/${item.app_id}`,
                class: "nav-link text-active-primary fs-7",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, " Application Id: " + _toDisplayString(item.app_id), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("span", _hoisted_11, _toDisplayString(item.app_file_count), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, _toDisplayString(item.files_approved), 1)
                  ])
                ])
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ], 64))
}